// src/data.js
const nameDetails = [
    {
      name: 'John',
      age: 30,
      city: 'New York',
      isSigned: false,
      resume:'Self-motivated problem solver with experience in Android development using GitHub and Java. Designed and maintained the applications   full stacks through design, testing and deployment.'
    },
    {
      name: 'Alice',
      age: 25,
      city: 'Los Angeles',
      isSigned: false,
      resume: 'file.txt',
    },
    {
      name: 'Bob',
      age: 35,
      city: 'Chicago',
      isSigned: false,
      resume: 'file.txt'
    },
    // Add more entries as needed
  ];
  
  export default nameDetails;
  